import SearchParamsBase from '../../../../Elements/SearchParamsBase';

export default class MyOfficeAssignmentSearchParams extends SearchParamsBase {
  static saveType = 'MyOfficeAssignmentSearchParams';
  initialize() {
    this.Type = '';
    this.AsCfId = '';
    this.CompletedDate = '';
  }
}
